import _objectSpread from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/deployments/firebase/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/**
 * Select.js
 *
 * A controlled Select component.
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { stringMatching, isRequired, useColors, useStrings, colorMatching } from '../Theme';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

function ReactSelect() {
  return React.createElement(Select);
}

function createDefault(_ref) {
  var defaultValue = _ref.defaultValue,
      options = _ref.options;
  var other = options[0];

  if (!defaultValue) {
    return other;
  }

  if (typeof defaultValue !== 'number') {
    return options.find(function (_ref2) {
      var value = _ref2.value;
      return value === defaultValue;
    }) || other;
  }

  return options[defaultValue] || other;
}

function ControlledSelect(_ref3) {
  var name = _ref3.name,
      props = _ref3.props,
      allows = _ref3.allows,
      control = _ref3.control,
      defaultValue = _ref3.defaultValue;
  var strings = useStrings();
  var options = allows.map(function (value) {
    return {
      value: value,
      label: stringMatching(strings, value)
    };
  });
  var defaultSelection = createDefault({
    options: options,
    defaultValue: defaultValue
  });
  var colors = useColors();
  return React.createElement(Controller, {
    name: name,
    as: ReactSelect(),
    control: control,
    rules: {
      required: isRequired(props)
    },
    options: options,
    defaultValue: defaultSelection,
    isSearchable: false,
    styles: {
      option: function option(provided, state) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          color: state.isSelected ? colorMatching(colors, 'neutral0') : colorMatching(colors, 'primary')
        });
      }
    },
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        borderRadius: 5,
        colors: _objectSpread(_objectSpread({}, _theme.colors), colors)
      });
    }
  });
}

function Main(_ref4) {
  var name = _ref4.name,
      props = _ref4.props,
      errors = _ref4.errors,
      control = _ref4.control,
      defaultValue = _ref4.defaultValue;
  var required = isRequired(props);
  var allows = props.allows;
  var strings = useStrings();
  return React.createElement(React.Fragment, null, React.createElement('label', null, stringMatching(strings, name, required)), React.createElement(ControlledSelect, {
    name: name,
    props: props,
    allows: allows,
    control: control,
    defaultValue: defaultValue
  }), errors[name] && React.createElement('p', null, "Please provide valid ".concat(stringMatching(strings, name))));
}

export default Main;